import { ApiResponse, Issuer, IssuerCreateRequest, IssuerUpdateRequest } from '@arrived/models';

import { api, publicApi } from './api';
import { unwrapApiResponse } from './utils';

export const getIssuers = async () => {
  const response = await publicApi.get<ApiResponse<Issuer[]>>('/issuers');

  return unwrapApiResponse(response.data);
};

export const getIssuer = async (id: number) => {
  const response = await publicApi.get<ApiResponse<Issuer>>(`/issuers/${id}`);

  return unwrapApiResponse(response.data);
};

export const postIssuer = async (request: IssuerCreateRequest) => {
  const response = await api.post<ApiResponse<Issuer>>(`/issuers/`, request);

  return unwrapApiResponse(response.data);
};

export const patchIssuer = async (request: IssuerUpdateRequest) => {
  const response = await api.patch<ApiResponse<Issuer>>(`/issuers/${request.id}`, request);

  return unwrapApiResponse(response.data);
};

export const deleteIssuer = async (id: number) => {
  const response = await api.delete<ApiResponse<Issuer>>(`/issuers/${id}`);

  return unwrapApiResponse(response.data);
};
